var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0422 2.66724C11.568 3.58322 10.61 5.12961 8.90239 6.12119C7.19479 7.11277 5.38426 7.17406 4.85845 6.25807C4.33265 5.34209 5.29068 3.7957 6.99828 2.80412C8.70588 1.81254 10.5164 1.75126 11.0422 2.66724Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90411 7.91416C4.95572 7.91416 5.80822 9.52183 5.80822 11.505C5.80822 13.4882 4.95572 15.0958 3.90411 15.0958C2.8525 15.0958 2 13.4882 2 11.505C2 9.52183 2.8525 7.91416 3.90411 7.91416Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86188 16.7603C5.38769 15.8444 7.19822 15.9056 8.90583 16.8972C10.6134 17.8888 11.5715 19.4352 11.0457 20.3512C10.5199 21.2672 8.70932 21.2059 7.00172 20.2143C5.29412 19.2227 4.33608 17.6763 4.86188 16.7603Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9578 20.3492C12.432 19.4332 13.39 17.8868 15.0976 16.8952C16.8052 15.9036 18.6157 15.8424 19.1416 16.7583C19.6674 17.6743 18.7093 19.2207 17.0017 20.2123C15.2941 21.2039 13.4836 21.2652 12.9578 20.3492Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0959 15.0918C19.0443 15.0918 18.1918 13.4842 18.1918 11.501C18.1918 9.51784 19.0443 7.91017 20.0959 7.91017C21.1475 7.91017 22 9.51784 22 11.501C22 13.4842 21.1475 15.0918 20.0959 15.0918Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1381 6.23966C18.6123 7.15564 16.8018 7.09436 15.0942 6.10278C13.3866 5.1112 12.4285 3.56481 12.9543 2.64883C13.4801 1.73284 15.2907 1.79413 16.9983 2.78571C18.7059 3.77729 19.6639 5.32368 19.1381 6.23966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/informationIcon.b73005d9c3cb31aab83bac780cbcc32c.svg";
export { ForwardRef as ReactComponent };